/**
 * Wires CDP events to Effector effect completions, so analytics stays fully
 * decoupled from the UI hooks/components. Each conversion fires exactly once,
 * whenever the underlying API effect resolves, regardless of which component
 * triggered it.
 */
import { accountCreateFx } from "../../../entities/account";
import { quoteCreateFx } from "../../../entities/quote";
import { appointmentCreateFx } from "../../../entities/appointment";

import {
  trackAppointmentBooked,
  trackLeadCreated,
  trackQuoteCreated,
} from "./events";

let registered = false;

/** Idempotently subscribe CDP events to the booking effects. */
export const registerCdpBindings = (): void => {
  if (registered) return;
  registered = true;

  // Lead generated (tokens/generate succeeded) — the north-star conversion.
  accountCreateFx.done.watch(() => {
    trackLeadCreated();
  });

  // Estimate created.
  quoteCreateFx.done.watch(({ result }) => {
    trackQuoteCreated(result?.data?.quotes?.[0]?.id);
  });

  // Booking completed.
  appointmentCreateFx.done.watch(({ result }) => {
    trackAppointmentBooked(result?.data?.appointments?.[0]?.id);
  });
};
